import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { LegsShapeId } from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import fieldPortfolioData from './common/fieldsPortfolioData';
import { IFormFieldKey, IForm } from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import {
    allMetals,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './common/materialGroups';
import allLegs, { getLegsWithExceptions } from './common/shapesGroups';
import {
    fieldsTvUnitAddOns, fieldsTvUnitBorders, fieldsTvUnitDimensions, fieldsTvUnitMaterial,
} from './common/fieldsTvUnit';

const tvUnitStandForm: IForm = {
    formId       : PublishedFormId.TvUnitStand,
    type         : FormTypeId.TvUnit,
    thumbnailURL : '/resized-images/forms/tvUnitStand.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.Material,
        IFormFieldKey.Border,
        IFormFieldKey.Dimension,
        IFormFieldKey.LegsShape,
        IFormFieldKey.LegsMaterial,
        IFormFieldKey.AddOns,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        material  : fieldsTvUnitMaterial,
        border    : fieldsTvUnitBorders,
        dimension : fieldsTvUnitDimensions,
        legsShape : {
            value   : undefined,
            options : getLegsWithExceptions([LegsShapeId.TvNoLegs, ...allLegs],
                [
                    LegsShapeId.LegsMikado,
                    LegsShapeId.LegsVShaped,
                    LegsShapeId.LegsVShapedCentral,
                    LegsShapeId.LegsGreedy,
                    LegsShapeId.LegsHarmonious,
                    LegsShapeId.LegsMonastery,
                    LegsShapeId.LegsTrestleCross,
                    LegsShapeId.LegsRightCrossPiece,
                    LegsShapeId.LegsSquareCrossPiece,
                    LegsShapeId.LegsTrapezeCentral,
                    LegsShapeId.LegsCross,
                ]),
            required: true,
        },
        legsMaterial: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(
                    [
                        ...allSolidWoods,
                        ...allMetals,
                    ],
                    [
                        MaterialId.BlackLocust,
                        MaterialId.Douglas,
                        MaterialId.Redcedar,
                        MaterialId.Larch,
                        MaterialId.Padouk,
                        MaterialId.Ipe,
                        MaterialId.Ash,
                        MaterialId.AshOlive,
                        MaterialId.Chestnut,
                        MaterialId.Pine,
                        MaterialId.Mahogany,
                        MaterialId.Elm,
                        MaterialId.Alderwood,
                        MaterialId.Birch,
                        MaterialId.Ebony,
                        MaterialId.Garapa,
                        MaterialId.SheetMetal,
                        MaterialId.StainlessSteel,
                        MaterialId.Zinc,
                        MaterialId.Rust,
                    ],
                ),
                required: true,
            },
        },
        addOns         : fieldsTvUnitAddOns,
        additionalData : additionalDataFactory({
            budgetMin          : 600,
            budgetMax          : 6500,
            budgetDefaultValue : 2000,
        }),
        contact: fieldsContact,
    },
};

export default tvUnitStandForm;
